
import { Component, Vue } from 'vue-property-decorator'
import { SessionsApi } from '@/api/methods/auth/SessionsApi'

/**
 * 生徒ルートアクセス時のリダイレクト処理
 */
@Component
export default class RootView extends Vue {
  /**
   * 開始時の処理(自動遷移を行うため全てここで処理する)
   */
  private async created(): Promise<void> {
    this.$loading.start()

    // ログイン情報が存在する場合は生徒トップページに遷移
    try {
      // ログイン情報を取得(存在しない場合は例外が発生する)
      this.$appCookies.authStudent.get()
      // 認証情報が有効かをチェック
      await SessionsApi.check()

      this.$loading.complete()
      await this.$router.push('/student/top')
      return
    } catch {
      // 例外発生=ログイン情報がない
    }

    // 権限の認証情報が存在しない場合はログイン情報を削除し、ログイン画面に遷移
    this.$appCookies.removeAuth()
    this.$loading.complete()
    await this.$router.push('/student/login')
  }
}
